// extracted by mini-css-extract-plugin
module.exports = {"header":"styles-module--header--1d-iR","home":"styles-module--home--2SK_x","sectionContent":"styles-module--sectionContent--RvJs9"};